import * as Yup from 'yup';

// On EDIT the stored password is no longer returned by the API, so the password field loads blank.
// A blank password on edit means "keep the existing password" (the server preserves it), so password
// is only required when creating a new user. Pass `isNew` from the component.
export const buildUserSchema = (isNew) => Yup.object().shape({

    username: Yup.string().email("Please enter a valid email").required("Please enter your username"),
    password: isNew
        ? Yup.string().required("Please enter your password")
        : Yup.string(),
    firstName: Yup.string().required("Please enter your first name"),
    lastName: Yup.string().required("Please enter your last name"),
    locationId: Yup.number().min(1,"Please select a location"),
    roleId: Yup.number().min(1,"Please select a role"),
    emailTemplateId: Yup.number().test(
        "email-template-check",
        "Please select an email template",
        function(value){

            if(this.parent.checked){
                return value && value > 0;
            }
            else
                return true;
        }
    ),   
    packageIds: Yup.array().test(
        "package-ids-check",
        "Please select a package",
        function(value){
            if(this.parent.checked){
                return value && value.length > 0;
            }
            else
                return true;
        }
    ),    
})
